// extracted by mini-css-extract-plugin
export var card = "_51-0";
export var content = "_51-1";
export var contentLoading = "_51-2";